<template>
	<input type="radio">
</template>

<script>
export default {
	name: 'eia-radio-button',
};
</script>

<style lang="scss" scoped>
input {
	border-color: $color-grey-medium;
}
</style>
